// extracted by mini-css-extract-plugin
export default {"btn":"RightArrow_btn__5idTX","btnRight":"RightArrow_btnRight__wvlhs"};